// Auto-generated i18n batch (Batch 3) for client-landing section components.
// Static UI text only (default labels, buttons, placeholders, empty states).
// Props/DB-driven content is NOT included here.

export const es = {
  secServices: {
    defaultTitle: 'Nuestros Servicios',
    moreInfo: 'Más información',
  },
  secTestimonials: {
    defaultTitle: 'Testimonios',
    serviceLabel: 'Servicio:',
    trustIndicator: 'Más de {{count}} clientes satisfechos confían en nuestros servicios',
  },
  secCta: {
    responseTime: 'Respuesta en menos de 24 horas',
    freeConsulting: 'Asesoría gratuita',
    certifiedProfessionals: 'Profesionales certificados',
  },
  secContactForm: {
    address: 'Dirección',
    phone: 'Teléfono',
    email: 'Email',
    hours: 'Horarios',
    whatsapp: 'WhatsApp',
    formTitle: 'Contáctanos',
    infoTitle: 'Información de Contacto',
    sectionTitle: 'Contacto',
  },
  secFeatured: {
    loadError: 'Error al cargar las propiedades',
    empty: 'No hay propiedades destacadas disponibles',
    viewAll: 'Ver Todas las Propiedades',
  },
  secGallery: {
    defaultTitle: 'Galería',
    allCategories: 'Todas',
  },
  secBlog: {
    defaultTitle: 'Últimas Noticias',
    featuredBadge: 'DESTACADO',
    readMore: 'Leer más →',
    viewMore: 'Ver Más Artículos',
  },
};

export const en = {
  secServices: {
    defaultTitle: 'Our Services',
    moreInfo: 'More information',
  },
  secTestimonials: {
    defaultTitle: 'Testimonials',
    serviceLabel: 'Service:',
    trustIndicator: 'More than {{count}} satisfied clients trust our services',
  },
  secCta: {
    responseTime: 'Response in less than 24 hours',
    freeConsulting: 'Free consultation',
    certifiedProfessionals: 'Certified professionals',
  },
  secContactForm: {
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    hours: 'Hours',
    whatsapp: 'WhatsApp',
    formTitle: 'Contact Us',
    infoTitle: 'Contact Information',
    sectionTitle: 'Contact',
  },
  secFeatured: {
    loadError: 'Error loading properties',
    empty: 'No featured properties available',
    viewAll: 'View All Properties',
  },
  secGallery: {
    defaultTitle: 'Gallery',
    allCategories: 'All',
  },
  secBlog: {
    defaultTitle: 'Latest News',
    featuredBadge: 'FEATURED',
    readMore: 'Read more →',
    viewMore: 'View More Articles',
  },
};
